import { gql } from "@apollo/client";
const DELETE_ADDITIONAL_QUESTION = gql`
  mutation removeAdditionalQuestion($id: Int!) {
    removeAdditionalQuestion(id: $id) {
      question
    }
  }
`;
export default DELETE_ADDITIONAL_QUESTION;
